import {
  Col,
  ColType,
  Crud,
  CrudOption,
  CrudApi,
  CrudAction,
} from "../../comp/crud";
import {
  ApiClient,
  displayLeadStatus,
  getLeadStatusOpt,
  displayLeadType,
  getLeadTypeOpt,
} from "../../api/ApiClient";
import "../clientConfig/index.scss";
import { TextCell } from "../../comp/cell";
import { formatDate, displayStar } from "../../utils";
import { Typography, Tag, Button, Form, Modal, Toast, Banner } from "@douyinfe/semi-ui";
import { IconModalStroked } from "@douyinfe/semi-icons";
import React, { useEffect, useMemo, useState } from "react";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";

export interface LeadImportLogProps {
  batchNo?: string;
  importResult?: number;
}

const geImportResultOpts = async (): Promise<CrudOption[]> => {
  const statusOpts: any = [
    {
      label: "成功",
      value: 1,
      key: 1,
    },
    {
      label: "失败",
      value: 0,
      key: 0,
    },
  ];
  return statusOpts;
};

let apiClient = ApiClient.getDefault();
export default function LeadImportLogDetail(props: LeadImportLogProps) {
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
  const [assignFormApi, setAssignFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [selectedLeads, setSelectedLeads] = useState([] as any[]);
  const [assignSaving, setAssignSaving] = useState(false);
  const role = localStorage.getItem("role");
  const username = localStorage.getItem("username");

  let cols: Col[] = [
    {
      name: "客户ID",
      key: "leadId",
      hideInList: false,
      showInFilter: false,
      type: ColType.STRING,
    },
    {
      name: "姓名",
      key: "leadName",
      hideInEdit: true,
      showInFilter: true,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Button
            theme="borderless"
            type="primary"
            onClick={() => detailAction(record)}
          >
            {value}
          </Button>
        );
      },
    },
    {
      name: "城市",
      key: "city",
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },
    {
      name: "导入渠道",
      key: "source",
      hideInList: false,
      showInFilter: false,
      type: ColType.STRING,
    },
    {
      name: "客户类型",
      key: "leadType",
      colSort: 1,
      colFilterSort: 6,
      showInFilter: true,
      hideInCreate: true,
      render: (value, index) => displayLeadType(value),
      getOptions: () => Promise.resolve(getLeadTypeOpt()),
      type: ColType.SELECT,
      width: 100,
    },
    {
      name: "销售",
      key: "saleName",
      hideInList: false,
      showInFilter: false,
      type: ColType.STRING,
    },
    {
      name: "客户状态",
      key: "leadStatus",
      hideInEdit: true,
      showInFilter: true,
      render: (value, index) => {
        if (value == "PENDING_CONTACT") {
          return (
            <Tag
              color="red"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "UNREACHABLE") {
          return (
            <Tag
              color="blue"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "OUT_LEAD") {
          return (
            <Tag
              color="grey"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "INVITATION_IN_PROGRESS") {
          return (
            <Tag
              color="orange"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "NON_COMPLIANCE") {
          return (
            <Tag
              color="teal"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "PENDING_VISIT") {
          return (
            <Tag
              color="purple"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "VISITED") {
          return (
            <Tag
              color="green"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "SIGNED_CONTRACT") {
          return (
            <Tag
              color="violet"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "PAID") {
          return (
            <Tag
              color="yellow"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else {
          return (
            <Tag key={value} size="large" shape="circle" type="solid">
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        }
      },
      getOptions: () => Promise.resolve(getLeadStatusOpt()),
      type: ColType.SELECT,
    },
    {
      name: "手机号",
      key: "leadMobile",
      hideInEdit: true,
      showInFilter: false,
      type: ColType.STRING,
    },

    {
      name: "是否成功",
      key: "importResult",
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => geImportResultOpts(),
      render: (value, index) => {
        if (value == 0) {
          return <Typography.Text type="danger">{"失败"}</Typography.Text>;
        } else {
          return <Typography.Text type="success">{"成功"}</Typography.Text>;
        }
      },
    },

    {
      name: "导入结果",
      key: "resultMsg",
      showInFilter: true,
      type: ColType.STRING,
      render: (a) => <TextCell width={200} text={a} />,
    },
    {
      name: "撞库客户ID",
      key: "hitLeadId",
      hideInEdit: true,
      showInFilter: false,
      type: ColType.STRING,
    },
    {
      name: "撞库渠道",
      key: "hitSource",
      hideInEdit: true,
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "撞库客户星级",
      key: "hitStar",
      hideInEdit: true,
      showInFilter: true,
      render: (a) => displayStar(a),
      getOptions: () =>
        Promise.resolve([
          { label: "0星", value: "0", key: "0" },
          { label: "1星", value: "1", key: "1" },
          { label: "2星", value: "2", key: "2" },
          { label: "3星", value: "3", key: "3" },
          { label: "4星", value: "4", key: "4" },
          { label: "5星", value: "5", key: "5" },
        ]),
      type: ColType.SELECT,
    },
    {
      name: "撞库客户状态",
      key: "hitStatus",
      hideInEdit: true,
      showInFilter: true,
      render: (value, index) => {
        if (value == "PENDING_CONTACT") {
          return (
            <Tag
              color="red"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "UNREACHABLE") {
          return (
            <Tag
              color="blue"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "OUT_LEAD") {
          return (
            <Tag
              color="grey"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "INVITATION_IN_PROGRESS") {
          return (
            <Tag
              color="orange"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "NON_COMPLIANCE") {
          return (
            <Tag
              color="teal"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "PENDING_VISIT") {
          return (
            <Tag
              color="purple"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "VISITED") {
          return (
            <Tag
              color="green"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "SIGNED_CONTRACT") {
          return (
            <Tag
              color="violet"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else if (value == "PAID") {
          return (
            <Tag
              color="yellow"
              key={value}
              size="large"
              shape="circle"
              type="solid"
            >
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        } else {
          return (
            <Tag key={value} size="large" shape="circle" type="solid">
              {" "}
              {displayLeadStatus(value)}{" "}
            </Tag>
          );
        }
      },
      getOptions: () => Promise.resolve(getLeadStatusOpt()),
      type: ColType.SELECT,
    },
    {
      name: "撞库客户入库时间",
      key: "hitCreatedAt",
      hideInEdit: true,
      showInFilter: false,
      type: ColType.STRING,
    },
    {
      name: "批次号",
      key: "batchNo",
      hideInEdit: true,
      showInFilter: false,
      type: ColType.STRING,
    },
  ];

  let nowDate = new Date();
  const initFilterValues = {
    //createdAt: [nowDate, nowDate],
    batchNo: props.batchNo,
    importResult: props.importResult,
  };

  let startDateStr = formatDate(nowDate);
  let endDateStr = formatDate(nowDate);
  const initParams = {
    //createdAt: startDateStr + "," + endDateStr,
    batchNo: props.batchNo,
    importResult: props.importResult,
  };

  useEffect(() => {
    let currUsername;
    if (role == "op_manager" || role == "monitor" || role == "foreground") {
      currUsername = "root";
    } else {
      currUsername = username;
    }
    apiClient
      .getTeamMemberTreeAsOptsOfAny(currUsername)
      .then((opts) => setTeamMembersTree(opts));
  }, []);
  //打开详情
  const detailAction = (a: any) => {
    const w = window.open("about:blank");
    let queryParams = {
      ...crudApi?.getQueryParams(),
      type: "all",
    };
    if (w != null) {
      //获取表格data的id列表,过滤leaId为空的
      let ids = crudApi
        ?.getData()
        ?.filter((i) => i.leadId || i.hitLeadId)
        .map((i) => i.leadId||i.hitLeadId);

      const data = {
        id: a.leadId||a.hitLeadId,
        ids: ids,
        viewMode: true,
        visitMode: false,
        leadFrom: "report",
        queryParams: queryParams,
      };
      w.location.href =
        "/#/leadDetailNew?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  const handleAssignClick = async () => {
    setAssignSaving(true);
    try {
      await assignFormApi!.validate();
      await apiClient.request(
        "/leads/assign",
        "POST",
        undefined,
        assignFormApi!.getValues()
      );
      setSelectedLeads([]);
      crudApi?.refresh();

      setAssignSaving(false);
      setShowAssignModal(false);
    } catch (e) {
      setAssignSaving(false);
    }
  };

  const handleAssignButtonClick = (row: any, rows: any) => {
    if (rows.length == 0) {
      Toast.info("请选择客户");
      return;
    }
    let leads = [];
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].leadId) {
        leads.push({ id: rows[i].leadId, name: rows[i].leadName });
      }else if (rows[i].hitLeadId) {
        leads.push({ id: rows[i].hitLeadId, name: rows[i].hitLeadName });
      }
    }
    setSelectedLeads(leads);
    setShowAssignModal(true);
  };

  const assignAction: CrudAction = {
    name: "分配客户",
    action: handleAssignButtonClick,
  };

  const actions: CrudAction[] = [];
  actions.push(assignAction);

  const renderLabel = (label: any, item: any) => (
    <div
      style={{
        padding: "6px 8px",
        lineHeight: 1.0,
      }}
    >
      <div
        style={{
          fontWeight: 500,
          color: "var(--semi-color-text-0)",
          fontSize: 14,
        }}
      >
        {label}
        <span
          style={{
            fontSize: 12,
            color: "var(--semi-color-text-2)",
            marginLeft: 10,
          }}
        >
          {item.labelSubText}
        </span>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        style={{ width: 600, height: 600 }}
        title="分配客户"
        visible={showAssignModal}
        okText="分配"
        confirmLoading={assignSaving}
        onOk={handleAssignClick}
        onCancel={() => setShowAssignModal(false)}
      >
        <Form getFormApi={(formApi) => setAssignFormApi(formApi)}>
          <Form.TreeSelect
            placeholder="请选择分配给谁"
            rules={[{ required: true, message: "请填写" }]}
            style={{ width: "100%" }}
            field="assignToIds"
            label="销售"
            //defaultExpandAll
            checkRelation="unRelated"
            leafOnly
            multiple
            treeData={teamMembersTree}
            filterTreeNode
            showFilteredOnly={true}
            searchPlaceholder="请输入关键字开始搜索"
            renderLabel={renderLabel}
            autoAdjustOverflow={false}
            virtualize={{
              itemSize: 28,
              height: 400,
            }}
          ></Form.TreeSelect>

          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.map((l) => l.id)}
            style={{ width: "100%" }}
            multiple
            field="leadIds"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>
        </Form>
      </Modal>
      <Banner 
            type="warning"
            description="支持分配：1、导入成功的客户，2、导入撞库的客户(也可以在 [客户导入撞库] 功能分配)。其它失败的客户不支持分配"
        />

      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
        }}
        canUpdate={false}
        canCreate={false}
        canExport={true}
        name="导入日志"
        entityKey="leadImportLog"
        initFilterValues={initFilterValues}
        initParams={initParams}
        actions={actions}
        select={true}
        pageSize={50}
        cols={cols}
      />
    </div>
  );
}
